/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ateliere_Connect_Export_Complete_TitleInputs */



/**
* | output |
* | --- |
* | "Export Complete" |
*
* @param {Ateliere_Connect_Export_Complete_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ateliere_connect_export_complete_title = /** @type {((inputs?: Ateliere_Connect_Export_Complete_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ateliere_Connect_Export_Complete_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Exportation terminée")
	if (locale === "de") return /** @type {LocalizedString} */ ("Export abgeschlossen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Esportazione completata")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Экспорт завершен")
	if (locale === "es") return /** @type {LocalizedString} */ ("Exportación completa")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("导出完成")
	if (locale === "ja") return /** @type {LocalizedString} */ ("エクスポート完了")
	if (locale === "hi") return /** @type {LocalizedString} */ ("निर्यात पूर्ण")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Exportação concluída")
	return /** @type {LocalizedString} */ ("Export Complete")
});